import {Link} from "react-router-dom";
import {PUBLIC_URL} from './../../const'
import React from "react";

const PageTitle = (props) => {
    let tabs = props?.menuItems ?? null
    let icons = props?.menuIcons ?? []
    let id = props?.curID ?? 0
    let page = props?.curPage ?? ""
    const isHero = !!props.hero;

    let menuStyle = {}
    if (tabs){
      menuStyle = {maxHeight: "180px", overflow: "hidden"}
    }

    const homeLabel = props.homeLabel || "Home";

    return (
        <>
            <div className={`card ${isHero ? "border-0 shadow-sm rounded-4 mb-4 position-relative overflow-hidden" : "bg-primary-subtle shadow-none position-relative overflow-hidden mb-4"}`}>
                <div
                    className={`card-body py-3 px-3 px-lg-4`}
                    style={
                        isHero
                            ? {
                                background: "linear-gradient(135deg, #eef2ff 0%, #f8f9ff 100%)",
                                borderBottomLeftRadius: tabs ? 0 : undefined,
                                borderBottomRightRadius: tabs ? 0 : undefined,
                                maxHeight: 180,
                                overflow: "hidden",
                                ...menuStyle,
                            }
                            : menuStyle
                    }
                >
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-9">
                            <h3 className="fw-bold mb-2 text-dark">{props.title}</h3>
                            {props.subTitle && <div className={`mb-2 mb-lg-3 ${isHero ? "text-muted" : "text-muted"}`}>{props.subTitle}</div>}
                            <nav aria-label="breadcrumb">
                                <ol className={`breadcrumb ${isHero ? "mb-0 text-muted" : ""}`}>
                                    <li className="breadcrumb-item">
                                        <Link to={props.homeUrl} className={isHero ? "text-primary text-decoration-none fw-semibold" : "text-muted text-decoration-none"}>
                                            <span className="hide-menu">{homeLabel}</span>
                                        </Link>
                                    </li>
                                    {props.links && props.links.map((link, index) => (
                                        <li key={index} className="breadcrumb-item">
                                            <Link to={link.link} className={isHero ? "text-primary text-decoration-none fw-semibold" : "text-muted text-decoration-none"}>
                                                <span className="hide-menu">{link.name}</span>
                                            </Link>
                                        </li>
                                    ))}
                                    {<li className={`breadcrumb-item ${isHero ? "text-dark" : ""}`} aria-current="page">{props.subTitle || props.title}</li>}
                                </ol>
                            </nav>
                        </div>
                        <div className="col-12 col-lg-3 mt-3 mt-lg-0 d-none d-lg-block">
                            <div className="text-center">
                                <img src={`${PUBLIC_URL}/assets/images/breadcrumb/ChatBc.png`} alt="" className="img-fluid mb-n4" />
                            </div>
                        </div>
                    </div>
                </div>
                {tabs && <ul className={`nav user-profile-tab justify-content-end mt-0 ${isHero ? "bg-white rounded-0" : "bg-primary-subtle rounded-2 rounded-top-0"}`} id="pills-tab" role="tablist">
                    {tabs.map((tab, index) => {
                        const isActive = tab.page === page;
                        return (
                            <li key={index} className="nav-item" role="presentation">
                                <Link
                                    to={tab.link.replace(":id", id)}
                                    className={`nav-link hstack gap-2 rounded-0 py-6 ${isActive ? "active" : ""}`}
                                    id={`pills-${tab.page}-tab`}
                                    role="tab"
                                    aria-controls={`pills-${tab.page}`}
                                    aria-selected={isActive}
                                >
                                    {icons[tab.page]}
                                    <span className="d-none d-md-block">{tab.label}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>}
            </div>
        </>
    )
}

export default PageTitle
